import React, { Component } from 'react';
import { Table, Row, Button, DatePicker, message, Spin, Select } from 'antd';
import moment from 'moment';
import { data2_4, defaultTitleData } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import TableText from "../../TableText";
import compute from "./compute";
import { getJson, numConvert, moneyNumber } from "@/method";
import InputNumber from "./InputNumber";

const { MonthPicker, } = DatePicker;
const { Option } = Select;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(4, exponent) + 0.5) / Math.pow(4, exponent);
    } else {
        return parseInt(this * Math.pow(4, exponent) - 0.5) / Math.pow(4, exponent);
    }
}


class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY'),
            dateData: [],
            data: [],
            loadingSave: false,
            loading: true,
            print: false,
            titleData: {}
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
        let date = Number(this.state.date || "0");
        let dateData = [];
        let len = date - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });
    }



    computeNum = (data) => {
        data = compute(data, this.state.date);

        this.setState({
            data,
        });
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    onChangeTitle = (name, value) => {
        let data = this.state.titleData;
        data[name] = value;
        this.setState({ titleData: data });
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(data2_4);
        let data = JSON.parse(dataBegin);

        const dataBeginTitle = JSON.stringify(defaultTitleData);
        let titleData = JSON.parse(dataBeginTitle);
        fetch(`/_4_5_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {

            if (x.data.data && x.data.data.length > 0) {
                data = x.data.data;
            }
            if (x.data.title && x.data.title.id) {
                titleData = x.data.title;
            }
            this.computeNum(data);
            this.setState({ titleData, loading: false });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        dataFrom.append('titleData', JSON.stringify({ ...this.state.titleData, year, }));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_4_5', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id || !this.state.titleData.id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table4_5', 1.5, '4.50', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })
        });
    }

    render() {
        const { data, titleData, loading } = this.state;
        const width = document.body.offsetWidth - 5850 > 300 ? document.body.offsetWidth - 5850 : 300;
        const totalIndex = [];
        const columns = [{
            title: '-',
            fixed: 'left',
            children: [{
                fixed: 'left',
                title: <div>Upselling{'\n'}Total Revenue</div>,
                children: [{
                    title: 'Room Type',
                    dataIndex: 'name',
                    key: 'name',
                    align: 'center',
                    width,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'input',
                            name: "name",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }]
            }]
        }, {
            title: 'Jan.',
            children: [{
                title: !loading && <InputNumber
                    text={titleData['Jan']}
                    name="Jan"
                    onChange={this.onChangeTitle}
                />,
                children: [{
                    title: 'Room Nts',
                    key: 'Jan_Room_Nts',
                    dataIndex: "Jan_Room_Nts",
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Jan_Room_Nts",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'ADR',
                    key: 'Jan_ADR',
                    dataIndex: 'Jan_ADR',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'number',
                            name: "Jan_ADR",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'Revenue',
                    key: 'Jan_Revenue',
                    dataIndex: 'Jan_Revenue',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Jan_Revenue",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }]
            }]
        }, {
            title: 'Feb.',
            children: [{
                title: !loading && <InputNumber
                    text={titleData['Feb']}
                    name="Feb"
                    onChange={this.onChangeTitle}
                />,
                children: [{
                    title: 'Room Nts',
                    key: 'Feb_Room_Nts',
                    dataIndex: "Feb_Room_Nts",
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Feb_Room_Nts",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'ADR',
                    key: 'Feb_ADR',
                    dataIndex: 'Feb_ADR',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'number',
                            name: "Feb_ADR",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'Revenue',
                    key: 'Feb_Revenue',
                    dataIndex: 'Feb_Revenue',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Feb_Revenue",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }]
            }]
        }, {
            title: 'Mar.',
            children: [{
                title: !loading && <InputNumber
                    text={titleData['Mar']}
                    name="Mar"
                    onChange={this.onChangeTitle}
                />,
                children: [{
                    title: 'Room Nts',
                    key: 'Mar_Room_Nts',
                    dataIndex: "Mar_Room_Nts",
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Mar_Room_Nts",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'ADR',
                    key: 'Mar_ADR',
                    dataIndex: 'Mar_ADR',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'number',
                            name: "Mar_ADR",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'Revenue',
                    key: 'Mar_Revenue',
                    dataIndex: 'Mar_Revenue',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Mar_Revenue",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }]
            }]
        }, {
            title: 'Apr.',
            children: [{
                title: !loading && <InputNumber
                    text={titleData['Apr']}
                    name="Apr"
                    onChange={this.onChangeTitle}
                />,
                children: [{
                    title: 'Room Nts',
                    key: 'Apr_Room_Nts',
                    dataIndex: "Apr_Room_Nts",
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Apr_Room_Nts",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'ADR',
                    key: 'Apr_ADR',
                    dataIndex: 'Apr_ADR',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'number',
                            name: "Apr_ADR",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'Revenue',
                    key: 'Apr_Revenue',
                    dataIndex: 'Apr_Revenue',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Apr_Revenue",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }]
            }]
        }, {
            title: 'May.',
            children: [{
                title: !loading && <InputNumber
                    text={titleData['May']}
                    name="May"
                    onChange={this.onChangeTitle}
                />,
                children: [{
                    title: 'Room Nts',
                    key: 'May_Room_Nts',
                    dataIndex: "May_Room_Nts",
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "May_Room_Nts",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'ADR',
                    key: 'May_ADR',
                    dataIndex: 'May_ADR',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'number',
                            name: "May_ADR",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'Revenue',
                    key: 'May_Revenue',
                    dataIndex: 'May_Revenue',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "May_Revenue",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }]
            }]
        }, {
            title: 'Jun.',
            children: [{
                title: !loading && <InputNumber
                    text={titleData['Jun']}
                    name="Jun"
                    onChange={this.onChangeTitle}
                />,
                children: [{
                    title: 'Room Nts',
                    key: 'Jun_Room_Nts',
                    dataIndex: "Jun_Room_Nts",
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Jun_Room_Nts",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'ADR',
                    key: 'Jun_ADR',
                    dataIndex: 'Jun_ADR',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'number',
                            name: "Jun_ADR",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'Revenue',
                    key: 'Jun_Revenue',
                    dataIndex: 'Jun_Revenue',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Jun_Revenue",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }]
            }]
        }, {
            title: 'Jul.',
            children: [{
                title: !loading && <InputNumber
                    text={titleData['Jul']}
                    name="Jul"
                    onChange={this.onChangeTitle}
                />,
                children: [{
                    title: 'Room Nts',
                    key: 'Jul_Room_Nts',
                    dataIndex: "Jul_Room_Nts",
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Jul_Room_Nts",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'ADR',
                    key: 'Jul_ADR',
                    dataIndex: 'Jul_ADR',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'number',
                            name: "Jul_ADR",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'Revenue',
                    key: 'Jul_Revenue',
                    dataIndex: 'Jul_Revenue',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Jul_Revenue",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }]
            }]
        }, {
            title: 'Aug.',
            children: [{
                title: !loading && <InputNumber
                    text={titleData['Aug']}
                    name="Aug"
                    onChange={this.onChangeTitle}
                />,
                children: [{
                    title: 'Room Nts',
                    key: 'Aug_Room_Nts',
                    dataIndex: "Aug_Room_Nts",
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Aug_Room_Nts",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'ADR',
                    key: 'Aug_ADR',
                    dataIndex: 'Aug_ADR',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'number',
                            name: "Aug_ADR",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'Revenue',
                    key: 'Aug_Revenue',
                    dataIndex: 'Aug_Revenue',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Aug_Revenue",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }]
            }]
        }, {
            title: 'Sep.',
            children: [{
                title: !loading && <InputNumber
                    text={titleData['Sep']}
                    name="Sep"
                    onChange={this.onChangeTitle}
                />,
                children: [{
                    title: 'Room Nts',
                    key: 'Sep_Room_Nts',
                    dataIndex: "Sep_Room_Nts",
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Sep_Room_Nts",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'ADR',
                    key: 'Sep_ADR',
                    dataIndex: 'Sep_ADR',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'number',
                            name: "Sep_ADR",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'Revenue',
                    key: 'Sep_Revenue',
                    dataIndex: 'Sep_Revenue',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Sep_Revenue",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }]
            }]
        }, {
            title: 'Oct.',
            children: [{
                title: !loading && <InputNumber
                    text={titleData['Oct']}
                    name="Oct"
                    onChange={this.onChangeTitle}
                />,
                children: [{
                    title: 'Room Nts',
                    key: 'Oct_Room_Nts',
                    dataIndex: "Oct_Room_Nts",
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Oct_Room_Nts",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'ADR',
                    key: 'Oct_ADR',
                    dataIndex: 'Oct_ADR',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'number',
                            name: "Oct_ADR",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'Revenue',
                    key: 'Oct_Revenue',
                    dataIndex: 'Oct_Revenue',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Oct_Revenue",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }]
            }]
        }, {
            title: 'Nov.',
            children: [{
                title: !loading && <InputNumber
                    text={titleData['Nov']}
                    name="Nov"
                    onChange={this.onChangeTitle}
                />,
                children: [{
                    title: 'Room Nts',
                    key: 'Nov_Room_Nts',
                    dataIndex: "Nov_Room_Nts",
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Nov_Room_Nts",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'ADR',
                    key: 'Nov_ADR',
                    dataIndex: 'Nov_ADR',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'number',
                            name: "Nov_ADR",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'Revenue',
                    key: 'Nov_Revenue',
                    dataIndex: 'Nov_Revenue',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Nov_Revenue",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }]
            }]
        }, {
            title: 'Dec.',
            children: [{
                title: !loading && <InputNumber
                    text={titleData['Dec']}
                    name="Dec"
                    onChange={this.onChangeTitle}
                />,
                children: [{
                    title: 'Room Nts',
                    key: 'Dec_Room_Nts',
                    dataIndex: "Dec_Room_Nts",
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Dec_Room_Nts",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'ADR',
                    key: 'Dec_ADR',
                    dataIndex: 'Dec_ADR',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'number',
                            name: "Dec_ADR",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'Revenue',
                    key: 'Dec_Revenue',
                    dataIndex: 'Dec_Revenue',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'inputNumber',
                            name: "Dec_Revenue",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }]
            }]
        }, {

            title: 'YTD',
            children: [{
                title: !loading && <InputNumber
                    text={titleData['YTD']}
                    name="YTD"
                    onChange={this.onChangeTitle}
                />,
                children: [{
                    title: 'Room Nts',
                    key: 'YTD_Room_Nts',
                    dataIndex: 'YTD_Room_Nts',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'number',
                            name: "YTD_Room_Nts",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'ADR',
                    key: 'YTD_ADR',
                    dataIndex: 'YTD_ADR',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'number',
                            name: "YTD_ADR",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'Revenue',
                    key: 'YTD_Revenue',
                    dataIndex: 'YTD_Revenue',
                    align: 'center',
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: 'number',
                            name: "YTD_Revenue",
                            onChange: this.onChange,
                            totalIndex
                        };
                        return <TableText data={props} />
                    }
                }]
            }]
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table4_5" style={{ width: this.state.print ? 6200 : 'auto' }}>
                        <Row>4.5 Rooms Revenue Up-selling Program 客房收入增销计划</Row>
                        <Row className="table-month">
                            <Select
                                placeholder="请选择年份"
                                style={{ width: 120 }}
                                value={this.state.date}
                                onChange={(str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            >
                                {this.state.dateData.map((x, i) => {
                                    return (
                                        <Option value={x} key={x}>{x}</Option>
                                    )
                                })}
                            </Select>
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            style={{ width: this.state.print ? 6150 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 6150, y: 500 }}
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_4_5">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-5/4-5.js